import axios from "axios";
import { SERVER_URL } from "../socket";

export async function loadLabels(authHeaders) {
  const res = await axios.get(`${SERVER_URL}/api/labels`, { headers: authHeaders });
  return res.data;
}

export async function createLabel(payload, authHeaders) {
  const res = await axios.post(`${SERVER_URL}/api/labels`, payload, { headers: authHeaders });
  return res.data;
}

export async function updateLabel(id, payload, authHeaders) {
  const res = await axios.put(`${SERVER_URL}/api/labels/${id}`, payload, { headers: authHeaders });
  return res.data;
}

export async function deleteLabel(id, authHeaders) {
  const res = await axios.delete(`${SERVER_URL}/api/labels/${id}`, { headers: authHeaders });
  return res.data;
}
